/**
 * Card height measurement utilities for virtualized grids.
 * Measures the row container (SimpleGrid) directly for accurate height.
 */

/**
 * Find the row container (first element with multiple children)
 * and measure its height directly.
 *
 * This approach is more reliable than measuring individual cards because:
 * - Cards may have maxHeight constraints that clip content
 * - The row container reflects the actual rendered layout
 */
export function findElementHeight(
  el: Element,
  fallback: number,
  _context: string,
): number {
  // Find the row container (SimpleGrid - first element with multiple children)
  let grid: Element | null = el;
  while (grid && grid.children.length <= 1) {
    grid = grid.children[0] ?? null;
  }

  if (grid) {
    const height = grid.getBoundingClientRect().height;
    if (height > 0) return height;
  }

  return fallback;
}
